import { lazy, type ReactElement, Suspense } from 'react'

import { Skeleton } from '@/components/ui/skeleton'
import { cn } from '@/lib/utils'

import type { MapaProps } from './tipos'

export type { MapaProps, PinoDoMapa } from './tipos'
export { ZOOM_COM_ENDERECO, ZOOM_SEM_ENDERECO } from './tipos'

/**
 * O mapa SOB DEMANDA — o Leaflet e o CSS dele só baixam quando uma tela com mapa
 * abre. É o mesmo raciocínio da rota de Indicadores com o Recharts: o atendente
 * que nunca abre rastreamento não paga o download de uma biblioteca de mapa.
 */
const MapaLeaflet = lazy(() => import('./mapa-leaflet'))

export function Mapa(props: MapaProps): ReactElement {
  return (
    <Suspense
      fallback={
        <Skeleton
          className={cn('w-full rounded-radius', props.className)}
          aria-label="Carregando o mapa…"
        />
      }
    >
      <MapaLeaflet {...props} />
    </Suspense>
  )
}
